import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { PortalFlightItineraryGroupNode } from '@app/services/api/api.types';
import { FlightBadgeType } from '@app/components/badges/flight-badge/flight-badge.component';

@Component({
  selector: 'portal-option-details',
  templateUrl: './option-details.component.html',
  styleUrls: ['./option-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptionDetailsComponent {
  @Input() itineraries: PortalFlightItineraryGroupNode[];
  @Input() portalLink: string;
  @Input() withHiddenFlightsV2: boolean;

  protected flightBadgeType = FlightBadgeType;
}
